export default __webpack_public_path__ + "static/media/readLight.0cdc7399.png";